import React, { PureComponent } from 'react';

/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';
import { FormattedMessage } from 'react-intl';

import ButtonGroup from '@atlaskit/button/button-group';
import CustomThemeButton from '@atlaskit/button/custom-theme-button';
import Button from '@atlaskit/button/standard-button';
import InlineDialog from '@atlaskit/inline-dialog';
import Lozenge from '@atlaskit/lozenge';
import { gridSize } from '@atlaskit/theme';

import { Repository } from 'src/components/types';
import { RepositoryPrivilege } from 'src/sections/repository/types';
import urls from 'src/urls/source';

import messages from './lfs-tag.i18n';

const ButtonGroupContainer = styled.div`
  padding-top: ${gridSize() * 2}px;
`;

const LfsInfo = styled.div`
  max-width: 360px;
`;

type Props = {
  repository?: Repository;
  repositoryAccessLevel?: RepositoryPrivilege;
};

type State = {
  isOpen: boolean;
};

export default class FileContents extends PureComponent<Props, State> {
  state = {
    isOpen: false,
  };

  closeDialog = () => {
    this.setState({ isOpen: false });
  };

  openDialog = () => {
    this.setState({ isOpen: true });
  };

  renderDialog() {
    const { repository, repositoryAccessLevel } = this.props;

    if (!repository) {
      return null;
    }

    return (
      <LfsInfo>
        <h3>
          <FormattedMessage {...messages.header} />
        </h3>
        <p>
          <FormattedMessage {...messages.description} />{' '}
          <a href={urls.external.lfsInfo} target="_blank">
            <FormattedMessage {...messages.learnMoreLink} />
          </a>
        </p>
        <ButtonGroupContainer>
          <ButtonGroup>
            <Button onClick={this.closeDialog}>Close</Button>
            {repositoryAccessLevel === 'admin' ? (
              <CustomThemeButton
                appearance="link"
                href={urls.ui.lfsAdmin(repository.full_name)}
              >
                <FormattedMessage {...messages.viewAllLfsFilesLink} />
              </CustomThemeButton>
            ) : (
              []
            )}
          </ButtonGroup>
        </ButtonGroupContainer>
      </LfsInfo>
    );
  }

  render() {
    return (
      <InlineDialog
        content={this.renderDialog()}
        isOpen={this.state.isOpen}
        onClose={this.closeDialog}
      >
        <Button
          appearance="subtle-link"
          onClick={this.openDialog}
          spacing="none"
        >
          <Lozenge appearance="inprogress" isBold>
            Git LFS
          </Lozenge>
        </Button>
      </InlineDialog>
    );
  }
}
